import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';

import DialogModal from '../../common/DialogModal';

const styles = theme => ({
  input: {
    borderRadius: 2,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #D8DBDF',
    fontSize: '15px',
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    marginBottom: '24px',
  },

  button: {
    width: "200px",
    background: "#1A65FF",
  },

  buttonDelete: {
    background: "#F03A47",
    width: "200px",
  },
});

class DeleteAccountDialog extends React.Component {
  state = {
    value: this.props.value,
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value })
  }

  handleDelete = () => {
    this.props.delete();
    this.props.toggleDialog();
  }

  render() {
    const { classes, isOpen, toggleDialog } = this.props;
    return (
      <DialogModal
        classes={{ paper: classes.paper }}
        open={isOpen}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        onClose={toggleDialog}
        title="アカウントを削除"
      >
        <Typography align="left">
          アカウントを削除すると、すべてのアドレス、キャンペーン、テンプレートが永久に削除されます。この操作は元に戻せません。
        </Typography>
        <TextField
          type="text"
          margin="normal"
          InputProps={{
            disableUnderline: true,
            classes: {
              input: classes.input,
            },
          }}
          placeholder="確認のため'delete'と入力してください"
          onChange={this.handleChange}
          fullWidth
        />

        <Button
          color="secondary"
          className={classes.buttonDelete}
          variant="raised"
          onClick={this.handleDelete}
          disabled={this.state.value !== 'delete'}
          fullWidth >
          アカウントを削除
        </Button>
      </DialogModal>
    );
  }
}

DeleteAccountDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default withStyles(styles)(DeleteAccountDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/DeleteAccountDialog.jsx